import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-coupons-wallet-stamp',
  templateUrl: './empty-coupons-wallet-stamp.component.html',
  styleUrls: ['./empty-coupons-wallet-stamp.component.scss'],
})
export class EmptyCouponsWalletStampComponent  implements OnInit {
  @Input() mode:'button'
  constructor() { }

  ngOnInit() {}

}
